import FixedTable from "../../../Layout/Components/Table/FixedTable";
import Loading from "../../../Layout/Components/Loading";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useCoupoms } from "../../../../Hook/Financial/useCoupoms";

export default function CouponDiscount({ idClient }) {
    const { t } = useTranslation();
    const { coupons, loading, fetchCoupons } = useCoupoms({ idClient }); // Custom hook to fetch coupons

    // Configura a rtabela de exibição
    const tableColumns = [
        {
            field: "id",
            label: "#",
            type: "number",
        },
        {
            field: "description",
            label: t("financial.coupon-discount.table.description"),
            type: "string",
            style: { textTransform: "uppercase" },
        },
        {
            field: "percent",
            label: t("financial.coupon-discount.table.percent"),
            type: "boolean",
        },
        {
            field: "discount",
            label: t("financial.coupon-discount.table.discount"),
            type: (row) => {
                return row.percent ? "percent" : "currency";
            },
        },
        {
            field: "days_use_label",
            label: t("financial.coupon-discount.table.days-use"),
            type: "string",
        },
        {
            field: "limit_use",
            label: t("financial.coupon-discount.table.limit-use"),
            type: "number",
        },
        {
            field: "used",
            label: t("financial.coupon-discount.table.used"),
            type: "number",
        },
        {
            field: "expire_at",
            label: t("financial.coupon-discount.table.expire-at"),
            type: "date",
        },
        {
            field: "is_active",
            label: t("financial.coupon-discount.table.is-active"),
            type: "boolean",
        },
        {
            field: "create_user.name",
            label: t("financial.coupon-discount.table.create-user"),
            type: "string",
        },
        {
            field: "create_at",
            label: t("financial.coupon-discount.table.create-at"),
            type: "date-time",
        },
        {
            field: "update_user.name",
            label: t("financial.coupon-discount.table.update-user"),
            type: "string",
        },
        {
            field: "update_at",
            label: t("financial.coupon-discount.table.update-at"),
            type: "date-time",
        },
    ];

    return (
        <>
            <Row className="account-receivable-coupon">
                {loading ? (
                    <Loading />
                ) : (
                    <FixedTable
                        table="clients_coupons"
                        columns={tableColumns}
                        data={coupons}
                        empty={t("financial.coupon-discount.table.empty")}
                        reload={fetchCoupons}
                    />
                )}
            </Row>
        </>
    );
}
